import React, { useEffect, useState } from "react";
import HolzfinderInput from "./HolzfinderInput";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { deDE } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { DateTime } from "luxon";
import { Alert } from "@mui/material";

export default function HolzfinderDateInputWithoutTime(
    { value, onChange, onValid, disablePast=false, hasError=false }: 
    { value: string; onChange: (value: string) => void; onValid?: (e: boolean) => void; disablePast?: boolean; hasError?: boolean }
) {
  const [editingValue, setEditingValue] = useState<DateTime | null>(
    value ? 
      DateTime.fromISO(value) : 
      DateTime.now()
  );
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (!editingValue || +editingValue !== +DateTime.fromISO(value)) {
      setEditingValue(
        value ? DateTime.fromISO(value) : DateTime.now()
      );
    }
  }, [value, editingValue]);
  useEffect(() => {
    const formattedValue = editingValue?.toISO() ?? "";
    onChange(formattedValue);
  }, [editingValue, onChange]);

  const handleDatePickerInput = (newValue: DateTime | null) => {
    if (newValue) {
      if (!newValue.isValid) {
        if(onValid) onValid(false);
        else setError("Bitte formatieren Sie das Datum wie folgt: dd-mm-yyyy");
        return;
      }
      if (newValue < DateTime.now() && disablePast) {
        if(onValid) onValid(false);
        else setError("Das Datum darf nicht in der Vergangenheit liegen.");
        return;
      } else {
        if(onValid) onValid(true);
        else setError(null);
        onChange(newValue.toISODate() || "");
      }
      setEditingValue(newValue);
    } else {
      if(onValid) onValid(false);
      else setError("Bitte formatieren Sie das Datum wie folgt: dd-mm-yyyy");
    }
  };

  const handleBlur = (newValue: DateTime | null) => {
    if (newValue) {
      onChange(newValue.toISODate() || "");
    }
  };

  return (
    <LocalizationProvider localeText={deDE.components.MuiLocalizationProvider.defaultProps.localeText} dateAdapter={AdapterLuxon} adapterLocale="de-DE" >
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <DesktopDatePicker
          inputFormat="dd-MM-yyyy"
          toolbarPlaceholder="tt-mm-yyyy"
          disablePast={disablePast}
          onChange={handleDatePickerInput}
          value={editingValue}
          onAccept={handleBlur}
          renderInput={(params) => <HolzfinderInput {...params} error={hasError || !!error} />}          
        />
        {error && 
          <div style={{ height: "56px" }}>
            <Alert severity="error" style={{position: "absolute"}}>{error}</Alert>
          </div>
        }
      </div>
    </LocalizationProvider>
  );
}
